import { render, staticRenderFns } from "./UsersHeader.vue?vue&type=template&id=7c5f70ea&scoped=true&"
import script from "./UsersHeader.vue?vue&type=script&lang=js&"
export * from "./UsersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5f70ea",
  null
  
)

export default component.exports